module.exports = {
      id: "banana-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#banana",
      toString: function () {
        return this.url;
      }
    }